import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CacheService } from 'mapfre-auditlib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProfessionalCategoryService {

  className = 'ProfessionalCategoryService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getAll(cache = true, cacheKey = "allProfessionalCategories"): Observable<any[]> | any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<any[]>(environment.base_URL + "/professional-category-types").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newCategory(category) {
    return this.http.post(environment.base_URL + "/professional-category-types", category)
  }

  updateCategory(category, id) {
    return this.http.put(environment.base_URL + `/professional-category-types/${id}`, category)
  }
}
